"use strict";
/* General */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOfWeek = exports.MarginOrderStatus = exports.MarginPositionStatus = void 0;
/* Positions */
var MarginPositionStatus;
(function (MarginPositionStatus) {
    MarginPositionStatus["Cancelled"] = "CANCELLED";
    MarginPositionStatus["Closed"] = "CLOSED";
    MarginPositionStatus["Limit"] = "LIMIT";
    MarginPositionStatus["Open"] = "OPEN";
    MarginPositionStatus["Pending"] = "PENDING";
    MarginPositionStatus["Reject"] = "REJECT";
    MarginPositionStatus["Stop"] = "STOP";
})(MarginPositionStatus = exports.MarginPositionStatus || (exports.MarginPositionStatus = {}));
/* Transactions */
var MarginOrderStatus;
(function (MarginOrderStatus) {
    MarginOrderStatus["PositionOpened"] = "Position Opened";
    MarginOrderStatus["PositionPartiallyClosed"] = "Position Partially Closed";
    MarginOrderStatus["PositionClosed"] = "Position Closed";
    MarginOrderStatus["PositionClosedByTakeProfit"] = "Position Closed By Take Profit";
    MarginOrderStatus["PositionClosedByStopLoss"] = "Position Closed By Stop Loss";
    MarginOrderStatus["PositionClosingPending"] = "Position Closing Pending";
    MarginOrderStatus["OrderPlaced"] = "Order Placed";
    MarginOrderStatus["TakeProfitAttached"] = "Take Profit Attached";
    MarginOrderStatus["StopLossAttached"] = "Stop Loss Attached";
    MarginOrderStatus["OrderWorking"] = "Order Working";
    MarginOrderStatus["OrderPending"] = "Order Pending";
    MarginOrderStatus["TakeProfitPending"] = "Take Profit Pending";
    MarginOrderStatus["StopLossPending"] = "Stop Loss Pending";
    MarginOrderStatus["OrderModified"] = "Order Modified";
    MarginOrderStatus["TakeProfitModified"] = "Take Profit Modified";
    MarginOrderStatus["StopLossModified"] = "Stop Loss Modified";
    MarginOrderStatus["OrderTriggered"] = "Order Triggered";
    MarginOrderStatus["TakeProfitTriggered"] = "Take Profit Triggered";
    MarginOrderStatus["StopLossTriggered"] = "Stop Loss Triggered";
    MarginOrderStatus["OrderCancelled"] = "Order Cancelled";
    MarginOrderStatus["TakeProfitRemoved"] = "Take Profit Removed";
    MarginOrderStatus["StopLossRemoved"] = "Stop Loss Removed";
    MarginOrderStatus["OrderRejected"] = "Order Rejected";
    MarginOrderStatus["TakeProfitRejected"] = "Take Profit Rejected";
    MarginOrderStatus["StopLossRejected"] = "Stop Loss Rejected";
})(MarginOrderStatus = exports.MarginOrderStatus || (exports.MarginOrderStatus = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
    DayOfWeek[DayOfWeek["Sunday"] = 7] = "Sunday";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
//# sourceMappingURL=api.types.js.map